(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bogo-banner"] && !Shopify.designMode) return;
  try {
    (function () {
function init(root) {
      (root || document).querySelectorAll('[data-pm-bogo-duo]').forEach(function (el) {
if (el.dataset.pmReady) return;
el.dataset.pmReady = '1';
el.addEventListener('click', function () {
var form = el.closest('form');
if (!form) return;
var duo = form.querySelector('input[name="pm_mode"][value="duo"]');
if (duo) {
duo.checked = true;
duo.dispatchEvent(new Event('change', { bubbles: true }));
var variants = form.querySelector('[data-pm-variants]');
if (variants && variants.scrollIntoView) {
variants.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        });
      });
    }
if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', function () { init(); });
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-rating]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';
        el.addEventListener('click', function () {
          var target = el.getAttribute('data-target');
          if (!target) return;
          var dest = document.querySelector(target);
          if (dest) dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-birthstone-ring"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');
        var gems = bindModal('[data-pm-gems]', '[data-pm-gems-open]', '[data-pm-gems-close]');

        var confirmBtn = el.querySelector('[data-pm-gems-confirm]');
        if (confirmBtn && gems) confirmBtn.addEventListener('click', gems.close);

        // Größen-Label
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });

        // ---- Geburtssteine ----
        function checked(name) { return el.querySelector('input[name="' + name + '"]:checked'); }

        function setPreview(idx, input) {
          el.querySelectorAll('[data-pm-preview="' + idx + '"]').forEach(function (w) {
            w.textContent = '';
            if (input && input.dataset.img) {
              var img = document.createElement('img');
              img.src = input.dataset.img;
              img.alt = '';
              w.appendChild(img);
            }
          });
        }

        function updateGems() {
          var i1 = checked('pm_stone1');
          var i2 = checked('pm_stone2');
          var n = (i1 ? 1 : 0) + (i2 ? 1 : 0);

          el.querySelectorAll('[data-pm-gems-count]').forEach(function (c) { c.textContent = n + '/2'; });
          setPreview(1, i1);
          setPreview(2, i2);

          if (confirmBtn) confirmBtn.disabled = n !== 2;

          var foot = el.querySelector('[data-pm-gems-foot]');
          if (foot) foot.textContent = n + '/2 ' + (el.dataset.footNote || '');

          var trigger = el.querySelector('[data-pm-gems-open]');
          if (trigger) trigger.classList.toggle('is-complete', n === 2);

          var summary = el.querySelector('[data-pm-gems-summary]');
          if (summary) {
            if (n === 0) { summary.hidden = true; summary.textContent = ''; return; }
            summary.hidden = false;
            summary.textContent = '';
            if (i1) {
              summary.appendChild(document.createTextNode('1: '));
              var b1 = document.createElement('strong'); b1.textContent = i1.value; summary.appendChild(b1);
            }
            if (i1 && i2) summary.appendChild(document.createTextNode(' · '));
            if (i2) {
              summary.appendChild(document.createTextNode('2: '));
              var b2 = document.createElement('strong'); b2.textContent = i2.value; summary.appendChild(b2);
            }
          }
        }

        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-stone]')) updateGems();
        });
        updateGems();
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-gemstones"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');
        var gems = bindModal('[data-pm-gems]', '[data-pm-gems-open]', '[data-pm-gems-close]');

        var confirmBtn = el.querySelector('[data-pm-gems-confirm]');
        if (confirmBtn && gems) confirmBtn.addEventListener('click', gems.close);

        // Größen-Label
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });

        // ---- Geburtssteine ----
        function checked(name) { return el.querySelector('input[name="' + name + '"]:checked'); }

        function setPreview(idx, input) {
          el.querySelectorAll('[data-pm-preview="' + idx + '"]').forEach(function (w) {
            w.textContent = '';
            if (input && input.dataset.img) {
              var img = document.createElement('img');
              img.src = input.dataset.img;
              img.alt = '';
              w.appendChild(img);
            }
          });
        }

        function updateGems() {
          var i1 = checked('pm_stone1');
          var i2 = checked('pm_stone2');
          var n = (i1 ? 1 : 0) + (i2 ? 1 : 0);

          el.querySelectorAll('[data-pm-gems-count]').forEach(function (c) { c.textContent = n + '/2'; });
          setPreview(1, i1);
          setPreview(2, i2);

          if (confirmBtn) confirmBtn.disabled = n !== 2;

          var foot = el.querySelector('[data-pm-gems-foot]');
          if (foot) foot.textContent = n + '/2 ' + (el.dataset.footNote || '');

          var trigger = el.querySelector('[data-pm-gems-open]');
          if (trigger) trigger.classList.toggle('is-complete', n === 2);

          var summary = el.querySelector('[data-pm-gems-summary]');
          if (summary) {
            if (n === 0) { summary.hidden = true; summary.textContent = ''; return; }
            summary.hidden = false;
            summary.textContent = '';
            if (i1) {
              summary.appendChild(document.createTextNode('1: '));
              var b1 = document.createElement('strong'); b1.textContent = i1.value; summary.appendChild(b1);
            }
            if (i1 && i2) summary.appendChild(document.createTextNode(' · '));
            if (i2) {
              summary.appendChild(document.createTextNode('2: '));
              var b2 = document.createElement('strong'); b2.textContent = i2.value; summary.appendChild(b2);
            }
          }
        }

        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-stone]')) updateGems();
        });
        updateGems();
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-groesse"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');

        // ---- Größen-Label live ----
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-stackable-name-ring"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');

        // ---- Größen-Label live ----
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });

        // ---- Namensfeld: Filter + Zähler ----
        var nameInput = el.querySelector('[data-pm-name]');
        if (nameInput) {
          var counter = el.querySelector('[data-pm-name-counter]');
          var maxLen = parseInt(nameInput.getAttribute('maxlength'), 10) || 12;
          var lettersOnly = nameInput.getAttribute('data-letters-only') === '1';
          var toUpper = nameInput.getAttribute('data-uppercase') === '1';

          function sanitizeName() {
            var v = nameInput.value;
            if (lettersOnly) {
              // erlaubt: Buchstaben (inkl. Umlaute/Akzente), Leerzeichen, Bindestrich, Apostroph
              try { v = v.replace(/[^\p{L} '\-]/gu, ''); }
              catch (err) { v = v.replace(/[^A-Za-zÀ-ÿ '\-]/g, ''); }
            }
            if (toUpper) v = v.toUpperCase();
            if (v.length > maxLen) v = v.slice(0, maxLen);

            if (v !== nameInput.value) {
              var pos = nameInput.selectionStart;
              nameInput.value = v;
              try { nameInput.setSelectionRange(pos, pos); } catch (e) {}
            }
            if (counter) {
              counter.textContent = v.length + '/' + maxLen;
              counter.classList.toggle('is-full', v.length >= maxLen);
            }
          }

          nameInput.addEventListener('input', sanitizeName);
          sanitizeName();
        }
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
